<template>

  <div>
    <!-- Geçici firma oluşturma modal -->
    <b-modal
      id="modal-temporary-customer"
      ref="modal-temporary-customer"
      :title="$t('Geçici Firma Oluştur')"
      hide-footer
      @show="resetTemporaryCustomerData"
      @hidden="resetTemporaryCustomerData"
    >
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(saveTemporaryCustomer)"
          @reset.prevent="resetTemporaryCustomerData"
        >

          <validation-provider
            #default="validationContext"
            :name="$t('Geçici Firma Adı')"
            rules="required|min:2"
          >
            <b-form-group
              :label="$t('Geçici Firma Adı')"
              label-for="temporary_customer_name"
            >
              <b-form-input
                id="temporary_customer_name"
                v-model="temporaryCustomerData.name"
                autofocus
                autocomplete="off"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            :name="$t('Yetkili Adı')"
            rules=""
          >
            <b-form-group
              :label="$t('Yetkili Adı')"
              label-for="temporary_customer_manager_name"
            >
              <b-form-input
                id="temporary_customer_manager_name"
                v-model="temporaryCustomerData.manager_name"
                autofocus
                autocomplete="off"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            :name="$t('Yetkili Soyadı')"
            rules=""
          >
            <b-form-group
              :label="$t('Yetkili Soyadı')"
              label-for="temporary_customer_manager_surname"
            >
              <b-form-input
                id="temporary_customer_manager_surname"
                v-model="temporaryCustomerData.manager_surname"
                autofocus
                autocomplete="off"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            :name="$t('Yetkili E-Posta Adresi')"
            rules="email"
          >
            <b-form-group
              :label="$t('Yetkili E-Posta Adresi')"
              label-for="temporary_customer_manager_email"
            >
              <b-form-input
                id="temporary_customer_manager_email"
                v-model="temporaryCustomerData.manager_email"
                autofocus
                autocomplete="off"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              @click="saveData()"
            >
              {{ $t('Kaydet') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-sidebar
      id="add-new-user-sidebar"
      v-model="isEditTechnicalServiceDataSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-product-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ $t('Teknik Servis Kaydı') }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />

        </div>

        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(saveData)"
            @reset.prevent="resetForm"
          >
            <!-- Firma ad -->
            <validation-provider
              #default="validationContext"
              :name="$t('Firma')"
              rules="required"
            >
              <b-form-group
                :label="$t('Firma')"
                label-for="customer_id"
              >
                <b-row>
                  <b-col>

                    <b-button
                      v-if="technicalServiceData.customer_is_temporary!=true"
                      v-b-modal.modal-temporary-customer
                      block
                      variant="outline-primary"
                    >
                      {{ $t('Geçici Firma Oluştur') }}
                    </b-button>
                    <b-button
                      v-if="technicalServiceData.customer_is_temporary==true"
                      block
                      variant="outline-danger"
                      @click="technicalServiceData.customer_is_temporary=false; resetCustomerData()"
                    >
                      {{ $t('Geçici Firmayı Kaldır') }}
                    </b-button>
                    <hr>
                  </b-col>
                  <b-col md="12">
                    <vue-autosuggest
                      v-if="technicalServiceData.customer_is_temporary!=true"
                      :suggestions="customerSuggest.filteredCustomers"
                      :input-props="customerSuggest.inputProps"
                      :state="getValidationState(validationContext)"
                      :value="technicalServiceData.customer_name"
                      @selected="customerSelected"
                      @input="customerOnInputChanged"
                    >
                      <template slot-scope="{suggestion}">
                        <div class="d-flex align-items-center">

                          <div class="detail ml-50">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.name }}
                            </b-card-text>
                            <small class="text-muted">
                              {{ suggestion.item.id }}
                            </small>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                    <b-form-input
                      v-if="technicalServiceData.customer_is_temporary"
                      v-model="technicalServiceData.customer_name"
                      :state="getValidationState(validationContext)"
                      autocomplete="off"
                      readonly
                    />
                  </b-col>
                </b-row>

              </b-form-group>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>

            </validation-provider>
            <!-- Cihaz seri no -->
            <validation-provider
              #default="validationContext"
              :name="$t('Cihaz Seri No')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Cihaz Seri No')"
                label-for="m_serial_number"
              >
                <b-form-input
                  id="m_serial_number"
                  v-model="technicalServiceData.serial_number"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Cihaz Adedi-->
            <validation-provider
              #default="validationContext"
              :name="$t('Cihaz Adedi')"
              rules="required"
            >
              <b-form-group
                :label="$t('Cihaz Adedi')"
                label-for="m_piece"
              >
                <b-form-input
                  id="m_piece"
                  v-model="technicalServiceData.piece"
                  type="number"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Kayıt Başlığı -->
            <validation-provider
              #default="validationContext"
              :name="$t('Kayıt Başlığı')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Kayıt Başlığı')"
                label-for="m_title"
              >
                <b-form-input
                  id="m_title"
                  v-model="technicalServiceData.title"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Açıklama -->
            <validation-provider
              #default="validationContext"
              :name="$t('Açıklama')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Açıklama')"
                label-for="m_description"
              >
                <b-form-textarea
                  id="m_description"
                  v-model="technicalServiceData.description"
                  placeholder="İşlem Açıklaması Giriniz"
                  rows="3"

                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- İşleme Alınma Zamanı -->
            <validation-provider
              #default="validationContext"
              :name="$t('Servise Kabul Zamanı')"
              rules="required"
            >
              <b-form-group
                :label="$t('Servise Kabul Zamanı')"
                label-for="m_accept_date"
              >
                <flat-pickr
                  v-model="technicalServiceData.accept_date"
                  class="form-control"
                  :config="$staticParams.flatPickrConfig"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- İşlem -->
            <validation-provider
              #default="validationContext"
              :name="$t('İşlem')"
            >
              <b-form-group
                :label="$t('İşlem')"
                label-for="m_transaction"
              >
                <v-select
                  id="m_transaction"
                  v-model="technicalServiceData.transaction"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="transactionOptions"
                  label="title"
                  :clearable="false"
                  :reduce="val => val.value"
                  :state="getValidationState(validationContext)"
                >
                  <template #option="{ title, icon }">
                    <feather-icon
                      :icon="icon"
                      size="16"
                      class="align-middle mr-50"
                    />
                    <span> {{ title }}</span>
                  </template>
                </v-select>
              </b-form-group>
            </validation-provider>

            <!-- Durum -->
            <validation-provider
              #default="validationContext"
              :name="$t('Durum')"
            >
              <b-form-group
                :label="$t('Durum')"
                label-for="m_status"
              >
                <v-select
                  id="m_status"
                  v-model="technicalServiceData.status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  label="title"
                  :clearable="false"
                  :reduce="val => val.value"
                  :state="getValidationState(validationContext)"
                  :disabled="technicalServiceData.complete_date!=null"
                >
                  <template #option="{ color, title }">
                    <div
                      class="rounded-circle d-inline-block mr-50"
                      :class="`bg-${color}`"
                      style="height:10px;width:10px"
                    />
                    <span> {{ title }}</span>
                  </template>

                  <template #selected-option="{ color, title }">
                    <div
                      class="rounded-circle d-inline-block mr-50"
                      :class="`bg-${color}`"
                      style="height:10px;width:10px"
                    />
                    <span> {{ title }}</span>
                  </template>

                </v-select>
              </b-form-group>
            </validation-provider>
            <!-- Tamamlanma Zamanı-->
            <validation-provider
              v-if="technicalServiceData.status==0"
              #default="validationContext"
              :name="$t('Tamamlanma Zamanı')"
            >
              <b-form-group
                :label="$t('Tamamlanma Zamanı')"
                label-for="m_complete_date"
              >
                <flat-pickr
                  id="m_complete_date"
                  v-model="technicalServiceData.complete_date"
                  class="form-control"
                  :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ $t('Kaydet') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                {{ $t('Vazgeç') }}
              </b-button>
            </div>

          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Entries') }}</label>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-group
              :label="$t('Durum Filtresi')"
              label-for="m_status_filter"
            >
              <v-select
                id="m_status_filter"
                v-model="statusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                label="title"
                :reduce="val => val.value"
              >
                <template #option="{ color, title }">
                  <div
                    class="rounded-circle d-inline-block mr-50"
                    :class="`bg-${color}`"
                    style="height:10px;width:10px"
                  />
                  <span> {{ title }}</span>
                </template>

                <template #selected-option="{ color, title }">
                  <div
                    class="rounded-circle d-inline-block mr-50"
                    :class="`bg-${color}`"
                    style="height:10px;width:10px"
                  />
                  <span> {{ title }}</span>
                </template>

              </v-select>
            </b-form-group>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-if="false"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="addData"
              >
                <span class="text-nowrap">{{ $t('Teknik Servis Kaydı Oluştur') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTechnicalServiceListTable"
        class="position-relative"
        :items="fetchTechnicalServiceDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        small
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Actions -->
        <template #cell(status)="data">
          <b-badge :variant="getStatusType(data.item.status).color">
            {{ getStatusType(data.item.status).title }}   <span v-if="data.item.status==0">{{ data.item.complete_date }}</span>
          </b-badge>
        </template>
        <template #cell(transaction)="data">
          <span>{{ getTransactionType(data.item.transaction).title }}</span>

        </template>
        <template #cell(accept_date)="data">
          <b-badge :variant="'light-'+getFromNowColor(data.item)">
            <span>{{ $format_datetime(data.item.accept_date) }} <strong>({{ $moment(data.item.accept_date).fromNow() }})</strong> </span>
          </b-badge>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editData(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Düzenle') }} </span>
            </b-dropdown-item>

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTechnicalServiceData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BDropdown, BDropdownItem, BPagination, BSidebar, BFormGroup, BFormInvalidFeedback, BForm, BFormTextarea, BCardText, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import flatPickr from 'vue-flatpickr-component'
import { VueAutosuggest } from 'vue-autosuggest'
import useTechnicalServiceList from './useTechnicalServiceList'
import technicalServiceStoreModule from './technicalServiceStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BSidebar,
    BForm,
    BFormInput,
    flatPickr,
    BButton,
    BCardText,
    VueAutosuggest,
    BFormTextarea,
    BFormGroup,
    BFormInvalidFeedback,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      customerSuggest: {
        limit: 10,
        filteredCustomers: [],
        inputProps: {
          id: 'customer_id',
          class: 'form-control',
          placeholder: 'Firma Adı Giriniz Veya Geçici Firma Ekleyiniz',

        },
      },
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'technicalServiceData.customer_manager_id': function (newVal, oldVal) {
      this.customerManagerOptions.forEach(val => {
        if (newVal === val.id) {
          this.technicalServiceData.customer_manager_name = val.name
          this.technicalServiceData.customer_manager_surname = val.surname
          this.technicalServiceData.customer_manager_email = val.email
        }
      })
    },

  },
  methods: {
    getFromNowColor(value) {
      const m = this.$moment(value.accept_date) // or whatever start date you have
      const today = this.$moment().startOf('day')

      const days = Math.round(this.$moment.duration(today - m).asDays())

      if (days > 10 && value.status !== 0) {
        return 'danger'
      }
      if (days > 5 && value.status !== 0) {
        return 'warning'
      }
      return 'primary'
    },
    getStatusType(value) {
      let statusVal = null
      this.statusOptions.forEach(val => {
        if (val.value === value) {
          statusVal = val
        }
      })
      return statusVal
    },
    getTransactionType(value) {
      let transactionTypeVal = null
      this.transactionOptions.forEach(val => {
        if (val.value === value) {
          transactionTypeVal = val
        }
      })
      return transactionTypeVal
    },
    customerOnInputChanged(text) {
      if (text === '' || text === undefined) {
        return
      }
      store.dispatch('app/suggestCustomers', { name: text, limit: this.customerSuggest.limit })
        .then(response => {
          this.customerSuggest.filteredCustomers = [{
            data: response.data.data,
          }]
        })
    },
    customerSelected(option) {
      store.dispatch('app/fetchSingleCustomer', { id: option.item.id })
        .then(response => {
          const { data } = response.data
          this.technicalServiceData.customer_name = data.name

          const arr = []
          response.data.data.managers.forEach(val => {
            arr.push({
              label: `${val.name} (${val.email})`, value: val.id, name: val.name, surname: val.surname, email: val.email,
            })
            this.customerManagerOptions = arr
          })
        })

      this.technicalServiceData.customer_id = option.item.id
      this.technicalServiceData.representative_user = option.item.user_id
    },
    resetCustomerData() {
      this.technicalServiceData.customer_id = 0
      this.technicalServiceData.customer_name = ''
      this.technicalServiceData.customer_manager_id = 0
      this.technicalServiceData.customer_manager_name = ''
      this.technicalServiceData.customer_manager_surname = ''
      this.technicalServiceData.customer_manager_email = ''
    },
    saveTemporaryCustomer() {
      this.technicalServiceData.customer_is_temporary = true
      this.customerManagerOptions = []
      this.technicalServiceData.customer_id = 0
      this.technicalServiceData.customer_name = this.temporaryCustomerData.name
      this.technicalServiceData.customer_manager_id = 0
      this.technicalServiceData.customer_manager_name = this.temporaryCustomerData.manager_name
      this.technicalServiceData.customer_manager_surname = this.temporaryCustomerData.manager_surname
      this.technicalServiceData.customer_manager_email = this.temporaryCustomerData.manager_email
      this.$refs['modal-temporary-customer'].hide()
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    saveData() {
      if (this.technicalServiceData.id === 0) {
        store.dispatch('app-technical-service/addTechnicalServiceData', this.technicalServiceData)
          .then(() => {
            this.$refs.refTechnicalServiceListTable.refresh()
            this.isEditTechnicalServiceDataSidebarActive = false
            this.showSuccessMessage()
          })
      } else {
        store.dispatch('app-technical-service/updateTechnicalServiceData', this.technicalServiceData)
          .then(() => {
            this.$refs.refTechnicalServiceListTable.refresh()
            this.isEditTechnicalServiceDataSidebarActive = false
            this.showSuccessMessage()
          })
      }
    },
    editData(item) {
      this.technicalServiceData = JSON.parse(JSON.stringify(item))
      this.isEditTechnicalServiceDataSidebarActive = true
    },
    addData() {
      this.resettechnicalServiceData()
      this.isEditTechnicalServiceDataSidebarActive = true
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-technical-service'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, technicalServiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const editTechnicalServiceDataId = ref(0)

    const isEditTechnicalServiceDataSidebarActive = ref(false)
    const technicalServiceData = ref(null)
    const temporaryCustomerData = ref(null)
    const blankTemporaryCompanyData = {
      name: '',
      manager_name: '',
      manager_surname: '',
      manager_email: '',
    }
    const transactionOptions = [
      { value: 1, title: 'Onarım', icon: '' },
      { value: 2, title: 'Bakım', icon: '' },
      { value: 0, title: 'Diğer', icon: '' },
    ]
    const statusOptions = [
      { value: 1, title: 'İşleme Alındı', color: 'info' },
      { value: 2, title: 'Onaylandı', color: 'success' },
      { value: 3, title: 'Ücret Onayı', color: 'warning' },
      { value: 0, title: 'Tamamlandı', color: 'secondary' },

    ]
    const blanktechnicalServiceData = {
      id: 0,
      title: '',
      description: '',
      serial_number: '',
      piece: 1,
      transaction: 1,
      accept_date: null,
      customer_id: 0,
      customer_is_temporary: false,
      status: 1,
      complete_date: null,
      customer_name: '',
      customer_manager_name: '',
      customer_manager_surname: '',
      customer_manager_email: '',
      customer_manager_id: 0,
    }

    const {
      fetchTechnicalServiceDatas,
      tableColumns,
      perPage,
      currentPage,
      totalTechnicalServiceData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTechnicalServiceListTable,
      refetchData,

      // UI

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useTechnicalServiceList()
    const resetTemporaryCustomerData = () => {
      temporaryCustomerData.value = JSON.parse(JSON.stringify(blankTemporaryCompanyData))
    }
    resetTemporaryCustomerData()
    const resettechnicalServiceData = () => {
      technicalServiceData.value = JSON.parse(JSON.stringify(blanktechnicalServiceData))
    }
    resettechnicalServiceData()
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resettechnicalServiceData)
    return {

      // Sidebar
      isEditTechnicalServiceDataSidebarActive,
      fetchTechnicalServiceDatas,
      tableColumns,
      temporaryCustomerData,
      resetTemporaryCustomerData,
      perPage,
      transactionOptions,
      currentPage,
      totalTechnicalServiceData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      refFormObserver,
      technicalServiceData,
      resettechnicalServiceData,
      getValidationState,
      resetForm,
      editTechnicalServiceDataId,
      isSortDirDesc,
      refTechnicalServiceListTable,
      refetchData,
      statusOptions,
      // Filter
      avatarText,

      // UI
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      blanktechnicalServiceData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
